import React from 'react'

import Loading from 'components/base/Loading'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import Error from 'components/base/Form/Error'

import {
  RadioWrapperVertical,
  RadioWrapperHorizontal,
} from './styles'
import { Props } from './types'

const Radio: React.FC<Props> = ({
  alwaysShowError,
  children,
  defaultValue,
  direction,
  error,
  showLoading,
  showLoadingError,
  touched,
  valid,
  value,
  ...props
}): React.ReactElement => {
  const Wrapper =
    (direction === 'horizontal' && RadioWrapperHorizontal) ||
    RadioWrapperVertical

  if (showLoading) {
    return <Loading />
  }

  if (showLoadingError) {
    return <Paragraph theme={ParagraphTheme.centered}>An error has occurred.</Paragraph>
  }

  return (
    <Wrapper {...props} alwaysShowError={alwaysShowError} touched={touched} valid={valid} defaultValue={defaultValue as string} value={value as string}>
      {children}
      {(!valid && (touched || alwaysShowError) && (
        <Error name={props.name} alwaysShowError={alwaysShowError} touched={touched}>
          <span>{error}</span>
        </Error>
      )) ||
        undefined}
    </Wrapper>
  )
}

export default Radio
